import { jsx as _jsx } from "react/jsx-runtime";
export var DayChip = function (_a) {
    var children = _a.children, _b = _a.variant, variant = _b === void 0 ? 'default' : _b;
    var baseClasses = 'inline-flex items-center justify-evenly !border-none rounded-md py-0 h-6 min-w-[80px] capitalize';
    var variantClasses = variant === 'small'
        ? 'bg-cardDayChipBackgroundSmall text-cardDayChipFontSizeSmall text-cardDayChipTextColorSmall px-0'
        : 'bg-cardDayChipBackground text-cardDayChipFontSize text-cardDayChipTextColor px-4';
    return _jsx("div", { className: "".concat(baseClasses, " ").concat(variantClasses), children: children });
};
